export enum LoanType {
  InterestOnly = 1,
  PrincipalAndInterest = 2,
  // if changing or adding values, updadte all other methods (toString, toList).
}

// tslint:disable-next-line:no-namespace
export namespace LoanType {
  export function toString(loanType: LoanType): string {
    switch (loanType) {
      case LoanType.InterestOnly:
          return 'Interest only';
      case LoanType.PrincipalAndInterest:
        return 'Principal and interest';
      default:
        return null;
    }
  }

  export function listAll() {
    return [LoanType.PrincipalAndInterest, LoanType.InterestOnly];
  }

  export function parse(loanTypeStr: string): LoanType {
    return LoanType[loanTypeStr];
  }
}

export default LoanType;
